import { IClient } from "@wingspanhq/users/dist/lib/interfaces";
import { PaymentMethod } from "../steps/PaymentMethod";
import { OnboardingContext, OnboardingModulePaymentMethod } from "../types";
import {
  buildOnboardingStep,
  UseCreateOnboardingStep,
  useOnboardingStepQueryConfig
} from "../components/OnboardingFlowUtils";
import { useUserId } from "../../../query/hooks/helpers";
import { useClientQuery } from "../../../query/users/queries";
import {
  FlowStep,
  FlowStepStatus
} from "../../../shared/components/FlowSwitch/types";

const getStatus = (client?: IClient): FlowStepStatus => {
  const hasPaymentMethod =
    !!client?.profile.defaultPaymentMethod?.accountId ||
    !!client?.profile.defaultPaymentMethod?.paymentMethodId;

  if (hasPaymentMethod) {
    return "Complete";
  }

  return "None";
};

export const getPaymentMethodStepConfig = (
  _: OnboardingModulePaymentMethod,
  __: OnboardingContext,
  client?: IClient
): FlowStep => {
  const status = getStatus(client);

  return {
    title: "Payment method",
    slug: "payment-method",
    component: PaymentMethod,
    status,
    result: {
      Complete: {
        title: "Your payment method was added",
        description:
          "The payment method was added and can be used to send payments. Click continue for the next step."
      }
    }
  };
};

export const usePaymentMethodStep: UseCreateOnboardingStep<
  OnboardingModulePaymentMethod
> = modules => {
  const config = useOnboardingStepQueryConfig(modules, "payment_method");
  const userId = useUserId();
  const queryClient = useClientQuery(userId, config);

  return (onboardingModule, contextValue) =>
    buildOnboardingStep({
      getConfig: getPaymentMethodStepConfig,
      module: onboardingModule,
      context: contextValue,
      queries: [queryClient]
    });
};
